import { createSlice } from "@reduxjs/toolkit";
import { jobMonitorColumnList } from "../../const";

const initialState = {
  columnConfig: jobMonitorColumnList
};

const dynamicColumnSlice = createSlice({
  name: "dynamicColumn",
  initialState,
  reducers: {
    setColumnConfig(state, action) {
      return {
        ...state,
        columnConfig: action.payload,
      };
    },
    setValue(state, action) {
      const { key, value } = action.payload;
      state.columnConfig[key] = value;
    },
  },
});

export const { setColumnConfig, setValue } = dynamicColumnSlice.actions;
export default dynamicColumnSlice;
